import moment from "moment";
import { useDispatch } from "react-redux";

import { Divider } from "@seneca/senekit";

import useEffectOnMount from "seneca-common/utils/hooks/useEffectOnMount";

import { expandAssignmentIfNotExpanded } from "features/classroom/state/actions/sidebarUI";

import AssignmentAccordion from "../AssignmentAccordion";
import styles from "./AssignmentsList.module.scss";
import { useGetActiveWordId } from "./hooks/useGetActiveWordId";

type Props = {
  activeSectionId: string;
  assignmentIds: string[];
  now: moment.Moment;
};

export default function AssignmentsList({
  activeSectionId,
  assignmentIds,
  now
}: Props) {
  const dispatch = useDispatch();
  useEffectOnMount(() =>
    dispatch(expandAssignmentIfNotExpanded(assignmentIds[0]))
  );

  const activeWordId = useGetActiveWordId();

  return (
    <ol className={styles.wrapper}>
      {assignmentIds.map((assignmentId, index) => {
        return (
          <li className={styles.wrapper} key={assignmentId}>
            {index > 0 && <Divider direction="horizontal" />}
            <AssignmentAccordion
              activeSectionId={activeSectionId}
              activeWordId={activeWordId}
              assignmentId={assignmentId}
              now={now}
            />
          </li>
        );
      })}
    </ol>
  );
}
